/* Collection page — Island Index. Tabs (collections) with one gliding underline, availability + price filters,
   mobile filter sheet, Load more, saved pieces (localStorage) and the 1/2-column view. Results come from the
   Section Rendering API so the URL stays shareable and nothing reloads. */
(() => {
  const root = document.querySelector("[data-ii]");
  if (!root) return;
  const $ = (s, el = root) => el.querySelector(s), $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const sid = root.dataset.sectionId, perM = +root.dataset.perM || 8;
  const mobile = matchMedia("(max-width: 767px)");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const PRICE = { u50: [null, 49.99], mid: [50, 150], o150: [150.01, null] };
  const live = $("[data-ii-live]"), tabs = $("[data-ii-tabs]"), line = $("[data-ii-line]");
  const store = { get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };

  const fromUrl = (u) => {
    const p = u.searchParams, g = p.get("filter.v.price.gte"), l = p.get("filter.v.price.lte");
    return { path: u.pathname, avail: p.get("filter.v.availability") === "1", price: !g && !l ? "" : !g ? "u50" : !l ? "o150" : "mid", sort: p.get("sort_by") || "" };
  };
  let state = fromUrl(new URL(location.href));
  const build = (s) => {
    const p = new URLSearchParams(), pr = PRICE[s.price];
    if (s.avail) p.set("filter.v.availability", "1");
    if (pr) { if (pr[0] != null) p.set("filter.v.price.gte", pr[0]); if (pr[1] != null) p.set("filter.v.price.lte", pr[1]); }
    if (s.sort) p.set("sort_by", s.sort);
    const q = p.toString();
    return s.path + (q ? "?" + q : "");
  };
  const cache = new Map();
  const load = (u) => {
    const k = u + (u.includes("?") ? "&" : "?") + "section_id=" + encodeURIComponent(sid);
    if (!cache.has(k)) {
      const pr = fetch(k).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((t) => new DOMParser().parseFromString(t, "text/html"));
      pr.catch(() => cache.delete(k));
      cache.set(k, pr);
    }
    return cache.get(k);
  };
  const countOf = (doc) => (doc.querySelector("[data-ii-count]") || {}).textContent || "";

  /* ---------- Gliding underline ---------- */
  const placeLine = () => {
    const t = $(".ii-tab[aria-pressed='true'] span", tabs);
    if (!t) { line.style.width = "0"; return; }
    const a = tabs.getBoundingClientRect(), b = t.getBoundingClientRect();
    line.style.left = b.left - a.left + tabs.scrollLeft + "px";
    line.style.width = b.width + "px";
  };
  line.style.transition = "none"; placeLine();
  requestAnimationFrame(() => requestAnimationFrame(() => { line.style.transition = ""; }));
  if (document.fonts) document.fonts.ready.then(placeLine);
  addEventListener("resize", placeLine);
  const pressTab = (path) => {
    let hit = null;
    $$(".ii-tab", tabs).forEach((b) => { const on = new URL(b.dataset.iiTab, location.href).pathname === path; b.setAttribute("aria-pressed", on); if (on) hit = b; });
    placeLine();
    if (hit && tabs.scrollWidth > tabs.clientWidth) tabs.scrollTo({ left: hit.offsetLeft - (tabs.clientWidth - hit.offsetWidth) / 2, behavior: reduce ? "auto" : "smooth" });
  };

  /* ---------- Filter UI state ---------- */
  const setSwitch = (b, on) => b && b.setAttribute("aria-checked", on);
  const setPrice = (attr, key) => $$(`[${attr}]`).forEach((b) => b.setAttribute("aria-pressed", b.getAttribute(attr) === key));
  const syncUI = () => {
    setSwitch($("[data-ii-avail]"), state.avail);
    setPrice("data-ii-price", state.price);
    const n = (state.avail ? 1 : 0) + (state.price ? 1 : 0);
    $("[data-ii-fcount]").textContent = n ? ` (${n})` : "";
    const sort = $("[data-ii-sort]");
    if (sort) { sort.value = state.sort || "manual"; $("[data-ii-sort-label]").textContent = sort.options[sort.selectedIndex] ? sort.options[sort.selectedIndex].text : "Featured"; }
  };

  /* ---------- Results ---------- */
  let mobileLimit = perM, run = 0;
  const cards = () => $$("[data-ii-card]");
  const applyLimit = () => cards().forEach((c, i) => c.classList.toggle("is-over", i >= mobileLimit));
  const updateMore = () => {
    const grid = $("[data-ii-grid]"), more = $("[data-ii-more]");
    if (!grid || !more) return;
    const total = +grid.dataset.total, loaded = cards().length, shown = mobile.matches ? Math.min(loaded, mobileLimit) : loaded;
    $("[data-ii-showing]").textContent = `Showing ${shown} of ${total}`;
    more.hidden = shown >= total;
  };
  const saved = (() => { try { return JSON.parse(store.get("izu-saved")) || []; } catch (e) { return []; } })();
  const paintHearts = () => $$("[data-ii-heart]").forEach((b) => {
    const on = saved.includes(b.dataset.iiHeart);
    b.setAttribute("aria-pressed", on);
    b.setAttribute("aria-label", (on ? "Remove " : "Save ") + b.dataset.name);
  });
  const paintView = () => {
    const one = store.get("izu-ii-view") === "1", grid = $("[data-ii-grid]");
    if (grid) grid.classList.toggle("ii-grid--one", one);
    $$("[data-ii-view]").forEach((b) => b.setAttribute("aria-pressed", (b.dataset.iiView === "1") === one));
  };
  const initGrid = () => { paintHearts(); paintView(); applyLimit(); updateMore(); };

  const apply = async (push = true) => {
    const u = build(state), my = ++run, results = $("[data-ii-results]");
    results.classList.add("is-fading");
    let doc;
    try { [doc] = await Promise.all([load(u), new Promise((r) => setTimeout(r, reduce ? 0 : 230))]); }
    catch (e) { location.href = u; return; }
    if (my !== run) return;
    results.innerHTML = doc.querySelector("[data-ii-results]").innerHTML;
    const c = countOf(doc);
    $$("[data-ii-count]").forEach((el) => { el.textContent = c; });
    live.textContent = c;
    mobileLimit = perM; initGrid();
    if (push) history.pushState({ ii: 1 }, "", u);
    const top = results.getBoundingClientRect().top, bar = $("[data-ii-bar]").getBoundingClientRect().bottom;
    if (top < bar) scrollBy({ top: top - bar - 12, behavior: reduce ? "auto" : "smooth" });
    requestAnimationFrame(() => results.classList.remove("is-fading"));
  };

  const loadMore = async (btn) => {
    const grid = $("[data-ii-grid]");
    if (!grid) return;
    const before = mobile.matches ? Math.min(cards().length, mobileLimit) : cards().length;
    if (mobile.matches) mobileLimit += perM;
    if ((!mobile.matches || mobileLimit > cards().length) && grid.dataset.next) {
      btn.setAttribute("aria-busy", "true");
      try {
        const doc = await load(grid.dataset.next), g2 = doc.querySelector("[data-ii-grid]");
        if (g2) { grid.append(...g2.children); grid.dataset.next = g2.dataset.next || ""; }
      } catch (e) { location.href = grid.dataset.next; return; }
      btn.removeAttribute("aria-busy");
      if (!mobile.matches) mobileLimit = Math.max(mobileLimit, cards().length);
    }
    initGrid();
    cards().slice(before).forEach((c) => c.classList.add("is-new"));
    const next = cards()[before];
    if (next) { const a = $(".ii-card__name", next); if (a) a.focus({ preventScroll: true }); }
    live.textContent = $("[data-ii-showing]").textContent;
  };
  mobile.addEventListener("change", updateMore);

  /* ---------- Mobile filter sheet ---------- */
  const sheet = $("[data-ii-sheet]"), panel = sheet && $(".ii-sheet__panel", sheet);
  let pending = null, opener = null, countRun = 0;
  const syncSheet = () => {
    setSwitch($("[data-ii-savail]", sheet), pending.avail);
    setPrice("data-ii-sprice", pending.price);
    const my = ++countRun, show = $("[data-ii-show-n]", sheet);
    load(build({ ...state, ...pending })).then((doc) => { if (my === countRun) show.textContent = countOf(doc); }).catch(() => {});
  };
  const openSheet = (btn) => {
    opener = btn; pending = { avail: state.avail, price: state.price };
    sheet.hidden = false; document.documentElement.style.overflow = "hidden";
    syncSheet();
    requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add("is-open")));
    setTimeout(() => ($("[data-ii-savail]", sheet) || panel).focus(), reduce ? 0 : 60);
  };
  const closeSheet = () => {
    sheet.classList.remove("is-open"); document.documentElement.style.overflow = "";
    setTimeout(() => { sheet.hidden = true; }, reduce ? 0 : 450);
    if (opener) opener.focus();
  };
  if (sheet) sheet.addEventListener("keydown", (e) => {
    if (e.key === "Escape") { closeSheet(); return; }
    if (e.key !== "Tab") return;
    const f = $$("button:not([hidden]), a[href]", panel), first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Events ---------- */
  root.addEventListener("click", (e) => {
    const t = e.target.closest("button");
    if (!t || !root.contains(t)) return;
    const d = t.dataset;
    if (d.iiTab !== undefined) {
      const path = new URL(d.iiTab, location.href).pathname;
      if (path === state.path) return;
      state.path = path; pressTab(path); apply();
    } else if (t.hasAttribute("data-ii-avail")) { state.avail = !state.avail; syncUI(); apply(); }
    else if (d.iiPrice !== undefined) { state.price = d.iiPrice; syncUI(); apply(); }
    else if (t.hasAttribute("data-ii-clear")) {
      if (!state.avail && !state.price && t.closest(".ii-empty")) { state.path = new URL($(".ii-tab", tabs).dataset.iiTab, location.href).pathname; pressTab(state.path); }
      state.avail = false; state.price = ""; syncUI(); apply();
    }
    else if (t.hasAttribute("data-ii-open")) openSheet(t);
    else if (t.hasAttribute("data-ii-close")) closeSheet();
    else if (t.hasAttribute("data-ii-savail")) { pending.avail = !pending.avail; syncSheet(); }
    else if (d.iiSprice !== undefined) { pending.price = d.iiSprice; syncSheet(); }
    else if (t.hasAttribute("data-ii-sheet-clear")) { pending = { avail: false, price: "" }; syncSheet(); }
    else if (t.hasAttribute("data-ii-show")) {
      const changed = pending.avail !== state.avail || pending.price !== state.price;
      state = { ...state, ...pending }; syncUI(); closeSheet(); if (changed) apply();
    }
    else if (d.iiHeart !== undefined) {
      const i = saved.indexOf(d.iiHeart);
      if (i > -1) saved.splice(i, 1); else saved.push(d.iiHeart);
      store.set("izu-saved", JSON.stringify(saved)); paintHearts();
    }
    else if (d.iiView !== undefined) { store.set("izu-ii-view", d.iiView); paintView(); }
    else if (t.hasAttribute("data-ii-more-btn")) loadMore(t);
  });
  const sort = $("[data-ii-sort]");
  if (sort) sort.addEventListener("change", () => { state.sort = sort.value === "manual" ? "" : sort.value; syncUI(); apply(); });
  addEventListener("popstate", () => { state = fromUrl(new URL(location.href)); syncUI(); pressTab(state.path); apply(false); });

  initGrid();
})();
